import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

//  Import Navbar, HeroBanner and Footer
import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import Footer from "./components/Footer";

// Import Google Analytics
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";

//  Importing pages
import Home from "./pages/MainPage";
import About from "./pages/AboutUs";
import Privacy from "./pages/PrivacyPolicy";
import Terms from "./pages/TermsAndConditions";
import Contact from "./pages/ContactUs";
import Property from "./pages/PropertyDetails";
import { CookieSetting } from "cookiesetting-component";
import ScrollToTop from "./components/ScrollToTop";

const trackingId = "UA-131130661-9";
ReactGA.initialize(trackingId);

const history = createBrowserHistory();
history.listen((location) => {
  ReactGA.set({ page: location.pathname }); // Update  users current page
  ReactGA.pageview(location.pathname); // Reacord a pageview for the given page
});

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Router basename={process.env.PUBLIC_URL}>
          <ScrollToTop />
          <Navbar />
          <HeroBanner />
          <Switch>
            <Route exact path="/" component={Home} />
            <Redirect from="/index.html" to="/" />
            <Route exact path="/About" component={About} />
            <Route exact path="/privacy-policy" component={Privacy} />
            <Route exact path="/terms-and-conditions" component={Terms} />
            <Route exact path="/Contact" component={Contact} />
            <Route exact path="/Property/:PropertyId" component={Property} />
            <Route
              render={() => (
                <h1 className="text-center">
                  WE ARE SORRY.
                  <br />
                  BUT THE PAGE YOU REQUESTED WAS NOT FOUND
                </h1>
              )}
            />
          </Switch>
          <Footer />
          <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
